import React from 'react';
import { hydrate, render } from 'react-dom';
import { BrowserRouter as Router } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import App from './App';
import './styles/index.scss';
import reportWebVitals from './reportWebVitals';

import withContext, { Provider } from './Context';

const AppWithContext = withContext(App)

const AppHydrate = ( 
  <React.StrictMode>
    <Router>
      <HelmetProvider>
        <Provider>
          <AppWithContext />
        </Provider>
      </HelmetProvider>
    </Router>
  </React.StrictMode>
)

const rootElement = document.getElementById("root");
if (rootElement.hasChildNodes()) {
  hydrate(AppHydrate, rootElement);
} else {
  render(AppHydrate, rootElement);
}


// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
